var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, CustomElement, html, nothing, ifDefined } from '@sick-davinci/ce-decorators';
import { style } from './Tile.style';
import { Icon } from '../icon/Icon';
import { IconRef } from '../icon/IconRef';
/**
 * A `davinci-tile` is composed of a left-aligned image, a centered title and description and a right aligned icon.
 * The whole tile can be used as a link.
 * 
 * @example
 * ```html
 * <davinci-tile title="SICK" href="https://www.sick.com" target="_blank" icon="hardware/keyboard_arrow_right">
 *    <img src="https://cdn.sick.com/static_2019030609/_ui/desktop/common/images/base/pics/logo.png"/>
 * </davinci-tile>
 * <davinci-tile title="LMS" description="5.79 MB" href="./lms-manual.pdf" icon="image/picture_as_pdf"></davinci-tile>
 * <davinci-radio-button value="value1">
 * <davinci-tile title="Lector Software" description="Version: 1.0.0 | Added: 25.06.2018"></davinci-tile>
 * </davinci-radio-button>
 * ```
 * 
 * @slot {*} content
 * 
 * @deprecated will be removed in version 6.0.0
 */

export let Tile = (_dec = Component({
  tag: 'davinci-tile',
  style: [style],
  dependencies: [Icon, IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", Boolean), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", String), _dec(_class = (_class2 = class Tile extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "title", _descriptor, this);

    _initializerDefineProperty(this, "description", _descriptor2, this);

    _initializerDefineProperty(this, "href", _descriptor3, this);

    _initializerDefineProperty(this, "target", _descriptor4, this);

    _initializerDefineProperty(this, "download", _descriptor5, this);

    _initializerDefineProperty(this, "disabled", _descriptor6, this);

    _initializerDefineProperty(this, "icon", _descriptor7, this);

    _initializerDefineProperty(this, "iconSrc", _descriptor8, this);
  }

  render() {
    return html`
      <a class="container" href=${ifDefined(this.href)} target=${ifDefined(this.target)} download=${ifDefined(this.download)}>
        <div class="slotPlaceholder">
          <slot></slot>
        </div>
        <div class="content">
          <div class="title">
            ${this.title}
          </div>
          ${this._displayDescription()}
        </div>
        <div class="actionIcon">
          ${this._renderIcon()}
        </div>
      </a>
    `;
  }

  _displayDescription() {
    return this.description === undefined || '' ? nothing : html`<div class="description">${this.description}</div>`;
  }

  _renderIcon() {
    if (!!this.iconSrc) {
      return html`<davinci-icon-ref src=${this.iconSrc}></davinci-icon-ref>`;
    }

    if (!!this.icon) {
      return html`<davinci-icon icon=${this.icon}></davinci-icon>`;
    }

    return nothing;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "title", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "description", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "href", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "target", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "download", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "iconSrc", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
})), _class2)) || _class);
